namespace Matrix.Data {
    export interface DataReportColumn {
        Name?: string;
        Title?: string;
        Visible?: boolean;
        Type?: DataType;
        Size?: number;
        Scale?: number;
        FormatterType?: string;
        FormatterParams?: { [key: string]: any };
        DisplayFormat?: string;
        Alignment?: string;
        Width?: number;
        Sortable?: boolean;
        SortOrder?: number;
        GroupOrder?: number;
        SummaryType?: Serenity.SummaryType;
        EditorType?: string;
        EditorParams?: { [key: string]: any };
        FilteringType?: string;
        FilteringParams?: { [key: string]: any };
        FilteringIdField?: string;
        FilterOnly?: boolean;
        NotFilterable?: boolean;
        QuickFilter?: boolean;
        QuickFilterParams?: { [key: string]: any };
        QuickFilterSeparator?: boolean;
        QuickFilterCssClass?: string;
    }
}
